import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/balancete`

    return {
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        checkDate(data) {

            return repository.get(`${baseUrl}/check-date/${data}`)
        },
        list() {

            return repository.get(`${baseUrl}/list`)
        },
        store(params = {}) {

            return repository.post(`${baseUrl}`, params)
        },
    }
}